export default __webpack_public_path__ + "static/media/digitalHelp.02b9a74c.png";